import React, { useState } from "react";
import { format, differenceInDays } from "date-fns";
import { fr } from "date-fns/locale";
import { useTranslation } from "react-i18next";

const EventCard = ({
  image,
  startDate,
  endDate,
  time,
  title,
  description,
  location,
}) => {
  const { t } = useTranslation();
  const [imgFailed, setImgFailed] = useState(false);

  const formatDate = (date) => format(new Date(date), "d MMMM yyyy", { locale: fr });
  const calculateDuration = (start, end) =>
    differenceInDays(new Date(end), new Date(start)) + 1;

  const formattedStartDate = startDate ? formatDate(startDate) : t("event.date_unknown");
  const formattedEndDate = endDate ? formatDate(endDate) : null;
  const duration = startDate && endDate ? calculateDuration(startDate, endDate) : null;

  return (
    <div
      className="bg-white rounded-2xl border shadow-sm overflow-hidden transition-all duration-300 hover:shadow-lg"
      style={{ borderColor: "rgba(120,90,40,0.15)" }}
    >
      {/* Bandeau image uniquement si une vraie image est fournie ET qu'elle charge */}
      {image && !imgFailed && (
        <div className="h-52 w-full overflow-hidden">
          <img
            src={image}
            alt={title}
            loading="lazy"
            decoding="async"
            onError={() => setImgFailed(true)}
            className="w-full h-full object-cover"
          />
        </div>
      )}

      <div className="p-6 md:p-8">
        {/* Pastille date */}
        <div className="inline-flex items-center rounded-full px-4 py-1.5 mb-4" style={{ backgroundColor: "#F4ECDD" }}>
          <span className="font-sans text-sm tracking-wide" style={{ color: "#A9760F" }}>
            {formattedStartDate}
            {formattedEndDate && ` — ${formattedEndDate}`}
          </span>
        </div>

        <h3 className="font-sans text-2xl text-stone-900 mb-4">{title}</h3>

        {/* Méta */}
        <div className="flex flex-col gap-2 font-nunito text-stone-600 mb-4">
          <span className="flex items-center gap-2">
            <span style={{ color: "#C8951F" }}>◦</span>
            {location || t("event.location_unknown")}
          </span>
          {duration && (
            <span className="flex items-center gap-2">
              <span style={{ color: "#C8951F" }}>◦</span>
              {t("event.duration")} : {duration} {duration > 1 ? t("event.days") : t("event.day")}
            </span>
          )}
          {time && (
            <span className="flex items-center gap-2">
              <span style={{ color: "#C8951F" }}>◦</span>
              {t("event.time")} : {time}
            </span>
          )}
        </div>

        {description && (
          <p className="font-nunito text-stone-600 leading-relaxed">{description}</p>
        )}
      </div>
    </div>
  );
};

export default EventCard;